/**
 * @file: BotAvatar.tsx
 *
 * Default avatar tile for a chat-bot (服务助手) room member — a customer-
 * service headset glyph on a rounded brand-colored tile. Shown when a bot
 * member has no custom avatar of its own.
 */

import { FC, memo } from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const BOT_GLYPH_PATH =
  'M746.666667 699.528533v-293.137066c0-135.168-105.0624-244.804267-234.666667' +
  '-244.804267s-234.666667 109.602133-234.666667 244.804267v353.621333c0 16.1792' +
  '-11.502933 29.320533-25.668266 29.320533H145.339733c-56.695467 0-102.673067' +
  '-52.5312-102.673066-117.3504V554.666667c0-64.8192 45.9776-117.3504 102.673066' +
  '-117.3504H201.045333v-35.157334C201.045333 227.1232 340.2752 85.333333 512 ' +
  '85.333333s310.954667 141.824 310.954667 316.791467v35.191467h55.7056c56.695467 ' +
  '0 102.673067 52.565333 102.673066 117.3504v117.3504c0 64.785067-45.9776 ' +
  '117.316267-102.673066 117.316266h-104.277334a351.095467 351.095467 0 0 1' +
  '-260.608 117.316267H452.266667a57.617067 57.617067 0 0 1-57.617067-57.617067v' +
  '-2.082133c0-31.812267 25.770667-57.617067 57.617067-57.617067h60.757333c24.064 ' +
  '0 44.680533 14.7456 53.316267 35.703467a276.036267 276.036267 0 0 0 180.292266' +
  '-125.508267z';

export const BotAvatar: FC<{ size: number; radius?: number }> = memo(
  ({ size, radius }) => (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: radius ?? size / 6,
        backgroundColor: '#3b82f6',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Svg width={size * 0.56} height={size * 0.56} viewBox="0 0 1024 1024">
        <Path fill="#ffffff" d={BOT_GLYPH_PATH} />
      </Svg>
    </View>
  ),
);
